var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"lines"},_vm._l((_vm.d),function(datum,index){return _c('line',{key:'circle-' + index,class:[
      'line',
      {
        selected:
          _vm.p.tooltipMove &&
          _vm.p.tooltipMove.datum &&
          _vm.p.tooltipMove.datum[_vm.c.xAxis] == datum[_vm.c.xAxis],
      },
      {
        lineNotHovered:
          _vm.hoveredStacked !== _vm.serie.key && _vm.hoveredStacked !== null,
      } ],attrs:{"x1":_vm.p.scaleX(datum[_vm.c.xAxis]),"x2":_vm.p.scaleX(datum[_vm.c.xAxis]),"y1":_vm.p.scaleY(datum[_vm.serie.key]),"y2":_vm.previousSerie ? _vm.p.scaleY(datum[_vm.previousSerie.key]) : _vm.p.scaleY(_vm.p.minY),"stroke-width":"2","stroke":"var(--primary-yellow)","opacity":"1"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }